// export const PAGINATION_BUTTON = "bg-[#CECECE]/[0.37] w-[30px] h-[30px] flex justify-center items-center rounded-sm shadow-md";
export const PAGINATION_BUTTON = " w-[30px] h-[30px] flex justify-center items-center rounded-sm shadow-md";
